import React, { FC, useEffect } from 'react'

import styled from 'styled-components'
import { useIntercom } from 'react-use-intercom'

import SearchIcon from 'src/Assets/Svg/search-icon.svg?react'
import { PrimaryInput } from 'src/Components/PrimaryInput'

import { useSpotifyWidgetSearch } from './useSpotifyWidgetSearch'
import { SpotifyWidgetList } from './SpotifyWidgetList'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SpotifyWidgetSearch: FC = () => {
  const { hardShutdown } = useIntercom()
  const { onSearchTrack, tracks, loading, error } = useSpotifyWidgetSearch()

  useEffect(() => {
    hardShutdown()
  }, [hardShutdown])

  const handleSearchHandler = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    onSearchTrack(event.target.value)
  }
  return (
    <Wrapper>
      <PrimaryInput
        placeholder='Type your track name or URL from Spotify'
        prefix={<SearchIcon width={'16px'} height={'16px'} />}
        onChange={handleSearchHandler}
      />
      <SpotifyWidgetList tracks={tracks} loading={loading} error={error} />
    </Wrapper>
  )
}
